import { render, staticRenderFns } from "./HomeGroupList.vue?vue&type=template&id=3c8174cd"
import script from "./HomeGroupList.vue?vue&type=script&lang=js"
export * from "./HomeGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports